/**
 * Display-seam normaliser for em and en dashes (product rule: no such dashes in
 * any user-facing copy). Applied where stored text is rendered or composed into
 * a snapshot; the stored source text is never rewritten.
 *
 *  - an unspaced dash between two numbers (a range such as "55–64", "$45,000–$54,999",
 *    "10–15%") stays exactly as written
 *  - any other unspaced dash becomes "-"
 *  - a spaced dash (a clause separator) becomes ", "
 *  - a trailing or leading stray dash is dropped
 */
const SPACED_DASH = /\s+[–—]\s+/g
const ANY_DASH = /\s*[–—]\s*/g
const RANGE_BEFORE = /[\d%]$/
const RANGE_AFTER = /^[$£€]?\d/

export function normalizeDashes(text: string): string {
  if (!text || !/[–—]/.test(text)) {
    return text
  }
  return text
    .replace(/[\s:]*[–—]\s*$/, '')
    .replace(/^\s*[–—]\s*/, '')
    .replace(SPACED_DASH, ', ')
    .replace(ANY_DASH, (match: string, offset: number, whole: string) => {
      const isBareDash = match.length === 1
      if (isBareDash && RANGE_BEFORE.test(whole.slice(0, offset)) && RANGE_AFTER.test(whole.slice(offset + 1))) {
        return match
      }
      return '-'
    })
}
